import categories from '@/utils/landing-page/dictionary-categories';
import { mapActions } from 'vuex';
export default {
    name: 'Categories',
    data: () => ({
        categories: [],
        categoriesCarousel: {
            sections: 0,
            sectionsRemainder: 0,
            sectionSize: 6,
            lastSection: 0
        }
    }),
    created() {
        this.categories = categories();
        this.categoriesCarousel.sections = parseInt(this.categories.length / this.categoriesCarousel.sectionSize);
        this.categoriesCarousel.sectionsRemainder = this.categories.length % this.categoriesCarousel.sectionSize;
        this.categoriesCarousel.lastSection = this.categoriesCarousel.sectionSize * this.categoriesCarousel.sections;
    },
    methods: {
        ...mapActions('supplierNetwork', ['clearSuppliers']),
        redirectToStructuredQuote(tagString = null) {
            let routeData;
            if (tagString) {
                routeData = this.$router.resolve({ name: 'StructuredQuote', query: { servico: tagString } });
            } else {
                routeData = this.$router.resolve({ name: 'StructuredQuote' });
            }
            window.open(routeData.href, '_blank');
            this.clearSuppliers();
        }
    }
};
